<template>

</template>

<script>
export default {
  asyncData({ redirect }) {
    redirect(301, '/suarapenentu')
  },
}
</script>
